<template>
  <div
    class="assistant-bubble rounded-br-sm-md! rounded-tl-sm-md! rounded-tr-sm-md! flex h-fit! min-w-0! flex-col items-start justify-between gap-3 bg-white/60 px-7 py-6"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AssistantStyleWrapper',
};
</script>
